// extracted by mini-css-extract-plugin
export default {"ExternalModuleContainer":"ExternalModuleContainer__nafqF9l6"};